//selectRedirectLocation DEPRECATED
//export const selectRedirectLocation = ({ auth }) => auth.redirectLocation;
export const selectSignInParamValue = ({ auth }) => auth.signInParamValue;
export const selectIsAuthenticated = ({ auth }) => auth.isAuthenticated;
